import React, { ReactNode } from 'react';
import { useDecision } from '@optimizely/react-sdk';

type FeatureFlagProps = {
  featureKey: string;
  children: ReactNode;
  fallback?: ReactNode;
};

/**
 * Higher Order Component that conditionally renders children based on feature flag status
 * @param featureKey - The Optimizely feature key to check
 * @param children - Content to render if feature is enabled
 * @param fallback - Optional content to render if feature is disabled (defaults to null)
 */
export const FeatureFlag: React.FC<FeatureFlagProps> = ({
  featureKey,
  children,
  fallback = null,
}) => {
  const [decision] = useDecision(featureKey);
  if (decision.enabled) {
    return <>{children}</>;
  }

  return <>{fallback}</>;
};
